import { createStyles, makeStyles } from '@material-ui/core/styles';
import { PRIMARY, RED } from 'constants/colors';
export default makeStyles(() => createStyles({
  variantError: {
    backgroundColor: `${RED}!important`
  },
  variantInfo: {
    backgroundColor: `${PRIMARY}!important`
  }
}));